import React from "react";
import { Box } from "@mui/material";
import type { FormattedNivelTP } from "../../../data/GetNivelesTP";
import ConfirmTabChangeModal from "../ConfirmTabChangeModal";
import type { FormattedAsignatura } from "../../../interfaces/ObjetivosAprendizaje/iAsignaturas";
import type GetNiveles from "../../../data/GetNiveles";
import { useProyecto } from "../../../data/ProyectoContext";
import { useAllowedTP } from "./useAllowedTP";
import CurriculumTabsABPHeader from "./CurriculumTabsABPHeader";
import CurriculumTabsABPContent from "./CurriculumTabsABPContent";
import {
  useCurriculumTabsABPLogic,
  type UseCurriculumTabsABPLogicParams,
} from "./useCurriculumTabsABPLogic";

type GetNivelesProps = React.ComponentProps<typeof GetNiveles>;

const BORDER_COLOR = "#D3D3D3";

export interface CurriculumTabsABPProps {

  nivelId: GetNivelesProps["selectedNivel"];
  handleNivelChangeABP: GetNivelesProps["onNivelChange"];

  selectedAsignatura: FormattedAsignatura | null;
  setSelectedAsignatura: React.Dispatch<
    React.SetStateAction<FormattedAsignatura | null>
  >;

  handleAsignaturaChangeLocalABP: (asignatura: FormattedAsignatura) => void;

  objetivosSeleccionados: any;
  setObjetivosSeleccionados: React.Dispatch<React.SetStateAction<any>>;
  setIsOAAdded: React.Dispatch<React.SetStateAction<boolean>>;

 
  nivelTPId: string;
  asignaturaTPId: string;
  handleNivelTPChange: (nivel: FormattedNivelTP) => void;
  handleAsignaturaTPChangeLocal: (a: { id: string; nombre: string }) => void;
  clearTP: () => void;


  promptData: {
    materia: string;
    nivel: string;
    [key: string]: any;
  };
  setPromptData: React.Dispatch<React.SetStateAction<any>>;
}

const CurriculumTabsABP: React.FC<CurriculumTabsABPProps> = (props) => {
  const { allowedTP, isLoadingTPInfo } = useAllowedTP();
  const { setProyecto } = useProyecto();

  const logicParams: UseCurriculumTabsABPLogicParams = {
    allowedTP,
    nivelId: props.nivelId,
    handleNivelChangeABP: props.handleNivelChangeABP,
    selectedAsignatura: props.selectedAsignatura,
    setSelectedAsignatura: props.setSelectedAsignatura,
    objetivosSeleccionados: props.objetivosSeleccionados,
    setObjetivosSeleccionados: props.setObjetivosSeleccionados,
    setIsOAAdded: props.setIsOAAdded,
    nivelTPId: props.nivelTPId,
    asignaturaTPId: props.asignaturaTPId,
    clearTP: props.clearTP,
    setPromptData: props.setPromptData,
  };

  const {
    tabValue,
    confirmTabChangeOpen,
    clearMode,
    onConfirmTabChange,
    onCancelTabChange,
    onChangeTab,

    isTecnicoProfesional,
    isOrganizacion,

    especialidadId,
    setEspecialidad,

    nivelOrg,
    setNivelOrg,
    asignaturaOrg,
    setAsignaturaOrg,

    emptyIdNombre,
  } = useCurriculumTabsABPLogic(logicParams);


  return (
    <Box sx={{ width: "100%", borderRadius: 2, bgcolor: "#FFFFFF" }}>
      <ConfirmTabChangeModal
        open={confirmTabChangeOpen}
        clearMode={clearMode}
        onConfirm={onConfirmTabChange}
        onCancel={onCancelTabChange}
      />

      <CurriculumTabsABPHeader
        tabValue={tabValue}
        onChange={onChangeTab}
        allowedTP={allowedTP}
        isLoadingTPInfo={isLoadingTPInfo}
        borderColor={BORDER_COLOR}
      />

      <CurriculumTabsABPContent
        tabValue={tabValue}
        isLoadingTPInfo={isLoadingTPInfo}
        allowedTP={allowedTP}
        isTecnicoProfesional={isTecnicoProfesional}
        isOrganizacion={isOrganizacion}
        especialidadId={especialidadId}
        setEspecialidad={setEspecialidad}
        clearTP={props.clearTP}
        nivelTPId={props.nivelTPId}
        asignaturaTPId={props.asignaturaTPId}
        handleNivelTPChange={props.handleNivelTPChange}
        handleAsignaturaTPChangeLocal={props.handleAsignaturaTPChangeLocal}
        nivelOrg={nivelOrg}
        setNivelOrg={setNivelOrg}
        asignaturaOrg={asignaturaOrg}
        setAsignaturaOrg={setAsignaturaOrg}
        emptyIdNombre={emptyIdNombre}
        nivelId={props.nivelId}
        handleNivelChangeABP={props.handleNivelChangeABP}
        selectedAsignatura={props.selectedAsignatura}
        setSelectedAsignatura={props.setSelectedAsignatura}
        handleAsignaturaChangeLocalABP={props.handleAsignaturaChangeLocalABP}
        promptData={props.promptData}
        setPromptData={props.setPromptData}
        objetivosSeleccionados={props.objetivosSeleccionados}
        setObjetivosSeleccionados={props.setObjetivosSeleccionados}
        setIsOAAdded={props.setIsOAAdded}
        setProyecto={setProyecto}
        borderColor={BORDER_COLOR}
      />
    </Box>
  );
};

export default CurriculumTabsABP;
